import { Provider } from '@angular/core';
import { MachineTaskApi } from './machine-task.api';
import { ToolingTaskApi } from './tooling-task.api';
import { DownloadApi } from './download.api';
import { KpiApi } from './kpi.api';
import { environment } from 'src/environment/environment';
import { US_BASE_URL } from './tokens';

export const apiProviders: Provider[] = [
  MachineTaskApi,
  ToolingTaskApi,
  DownloadApi,
  KpiApi,
  { provide: US_BASE_URL, useValue: environment.usBaseUrl },
];

export * from './settings.api';
export * from './machine-task.api';
export * from './tooling-task.api';
export * from './download.api';
export * from './kpi.api';
export * from './task-base.model';
export * from './task-base.api';
